import { cn } from "@/modern/utils";
import { isChecklistItemChecked, type Checklist, type ChecklistItem } from "../types";

interface ChecklistProgressProps {
  checklist: Checklist;
  checklistItems?: ChecklistItem[];
  barContainerClassName?: string;
  textClassName?: string;
}

export const ChecklistProgress = ({ checklist, checklistItems, barContainerClassName, textClassName }: ChecklistProgressProps) => {
  const items = checklistItems ?? [];

  let completedItems: number;
  let totalItems: number;

  if (items.length > 0) {
    completedItems = items.filter((item) => isChecklistItemChecked(item)).length;
    totalItems = items.length;
  } else if (typeof checklist.totalItems === "number" && checklist.totalItems > 0) {
    totalItems = checklist.totalItems;
    const left = typeof checklist.itemsLeft === "number" ? checklist.itemsLeft : totalItems;
    completedItems = Math.max(0, totalItems - left);
  } else {
    completedItems = 0;
    totalItems = 0;
  }

  const progress = totalItems > 0 ? (completedItems / totalItems) * 100 : 0;

  return (
    <div className="flex items-center gap-3">
      <div className={cn("flex-1 h-2 bg-secondary rounded-full overflow-hidden", barContainerClassName)}>
        <div className="h-full bg-primary rounded-full transition-all duration-300" style={{ width: `${progress}%` }} />
      </div>
      <span className={cn("text-sm text-muted-foreground whitespace-nowrap", textClassName)}>
        {completedItems} of {totalItems}
      </span>
    </div>
  );
};
